import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  FormControlLabel,
  Checkbox,
  Box,
  IconButton,
  Tooltip as MuiTooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const OrdendeVentaPerfectaBarChart = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = ['Alimentos', 'Retail', 'Servicios logísticos', 'Manufactura', 'Automotriz', 'Salud/Farmacéutica', 'Construcción'];
  const data2023 = [25, 22, 14, 12, 11, 10, 6];
  const data2024 = [20, 34, 16, 14, 8, 2, 6];

  const colorMap = {
    'Alimentos': '#172B3E',
    'Retail': '#1F3D58',
    'Servicios logísticos': '#476A8E',
    'Manufactura': '#4B73B1',
    'Automotriz': '#6D6D6D',
    'Salud/Farmacéutica': '#A2AEBB',
    'Construcción': '#B0B0B0',
  };

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;

  const dataValues2023 = labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 && data2023[index] !== undefined ? data2023[index] : 0;
  });
  
  const dataValues2024 = labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 && data2024[index] !== undefined ? data2024[index] : 0;
  });
  
  const backgroundColors = labels.map((label) => colorMap[label] || '#ccc');

  const chartData = {
    labels,
    datasets: [
      {
        label: '2022',
        data: dataValues2023,
        backgroundColor: backgroundColors,
      },
      {
        label: '2023',
        data: dataValues2024,
        backgroundColor: backgroundColors.map((color) => `${color}B3`), // versión más clara
      },
    ],
  };

  const options = {
    responsive: true,
    indexAxis: 'y', // 👈 esto lo convierte en horizontal
    plugins: {
      legend: {
        position: 'top',
        labels: { font: { size: 12, weight: 'bold' } },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label} - ${context.raw}%`,
        },
      },
      datalabels: {
        anchor: 'end',
        align: 'right',
        formatter: (value) => `${value}%`,
        font: { weight: 'bold' },
        color: '#000',
      },
    },
    scales: {
      x: {
        max: 100,
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
      },
      y: {
        title: {
          display: false,
        },
      },
    },
  };

  const handleSegmentClick = (industry) => {
    let updatedSelectedIndustries = [...selectedIndustries];
    if (updatedSelectedIndustries.includes(industry)) {
      updatedSelectedIndustries = updatedSelectedIndustries.filter((item) => item !== industry);
    } else {
      updatedSelectedIndustries.push(industry);
    }
    onBarClick(updatedSelectedIndustries);
  };

  const handleCheckboxChange = (industry) => {
    handleSegmentClick(industry);
  };

  const infoContent = {
    Analisis: ': El estudio muestra una mayor representatividad del sector Retail en 2023, seguido por una participación estable o en crecimiento en sectores clave como Servicios logísticos y manufactura. El cambio en participación puede reflejar prioridades operativas, presión del entorno económico, o disposición de cada industria para compartir datos logísticos',
    //formula: 'Total de piezas entregadas / Total de piezas solicitadas x 100',
    //description: 'Mide la cantidad de piezas surtidas frente a las solicitadas por el cliente, expresado como un porcentaje.',
  };

  return (
    <div style={{ width: '100%', maxWidth: '700px', margin: '0 auto' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Box display="flex" justifyContent="center" flexWrap="wrap" mb={2}>
        {allLabels.map((industry) => (
          <FormControlLabel
            key={industry}
            control={
              <Checkbox
                checked={selectedIndustries.includes(industry)}
                onChange={() => handleCheckboxChange(industry)}
                color="primary"
              />
            }
            label={industry}
          />
        ))}
      </Box>
      <div style={{ width: '100%', height: '400px' }}>
        <Bar data={chartData} options={options} />
      </div>
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OrdendeVentaPerfectaBarChart;
